import React from 'react';
interface TestimonialCardProps {
  name: string;
  age: number;
  text: string;
}
const TestimonialCard = ({
  name,
  age,
  text
}: TestimonialCardProps) => {
  return <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-id="element-199">
      <p className="text-lg mb-4 italic" data-id="element-200">"{text}"</p>
      <p className="text-right font-bold" data-id="element-201">
        – {name}, {age} lat
      </p>
    </div>;
};
export default TestimonialCard;